import ErrorsReport from './ErrorsReport';

export default ErrorsReport;
